import styled from 'styled-components';

import { Row, Col } from '@components/formStyles';
import Button from '@components/Button/next';
import IconLabel from '@components/ui/labels/icon/IconLabel';

export const StyledButton = styled(Button)<{ isSelected: boolean }>`
  width: 100%;
  height: 45px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 58px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    height: 39px;
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `border: 1px solid ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    box-shadow: none !important;
    pointer-events: none !important; `}
`;
export const StyledButtonDesktop = styled(Button)<{ isSelected: boolean }>`
  display: flex;
  font-size: 18px !important;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  width: 220px !important;
  height: 58px !important;

  ${({ isSelected, theme }) =>
    isSelected &&
    `border: 1px solid ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    box-shadow: none !important;
    pointer-events: none !important; `}
`;
export const StyledButtonMobile = styled(Button)<{ isSelected: boolean }>`
  border-radius: 8px;
  display: flex;
  font-size: 14px !important;
  align-items: center;
  font-weight: bold;
  justify-content: center;
  width: 100% !important;
  height: 45px !important;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    height: 39px !important;
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `border: 1px solid ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    box-shadow: none !important;
    pointer-events: none !important; `}
`;
export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  margin: 20px 14px 20px 0;
  padding: 20px 20px 11px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  &:hover {
    ${StyledButton} {
      background-color: ${({ theme }) => theme.palette.tomato};
      color: ${({ theme }) => theme.palette.white};
    }
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding: 20px 14px 11px;
  }
`;

export const Title = styled.span`
  margin: 0 2px 5px 0;
`;

export const Description = styled.span`
  word-wrap: break-word; /* IE */
  white-space: pre-wrap; /* CSS3 */

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 265px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
export const ChildPriceDesc = styled.span`
  white-space: normal;
`;
export const ChildPriceWrapper = styled.div<{
  bottomControl?: boolean;
  dailyPrice?: boolean;
}>`
  position: absolute;
  bottom: ${({ bottomControl, dailyPrice }) =>
    dailyPrice ? '60px' : bottomControl ? '220px' : '60px'};
  height: auto;
  display: flex;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    position: initial;
    margin-bottom: 20px;
  }
`;
export const Circle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.orange};
  margin-top: 6px;
  margin-right: 5px;
`;

export const Date = styled.span`
  width: 258px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const DistantRow = styled(Row)`
  justify-content: space-between;
`;
export const DistantColumn = styled(Col)`
  flex-direction: column;
  min-height: 230px;
`;
export const RightCol = styled(Col)`
  align-items: flex-end;
`;

export const LabelWrapper = styled.div<{
  bottomControl?: boolean;
  dailyPrice?: boolean;
}>`
  bottom: ${({ bottomControl, dailyPrice }) =>
    dailyPrice ? '10px' : bottomControl ? '180px' : '10px'};
  display: flex;
  align-items: flex-start;
  gap: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    bottom: ${({ bottomControl, dailyPrice }) =>
      dailyPrice ? '70px' : bottomControl ? '257px' : '100px'};
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: column;
    bottom: ${({ bottomControl, dailyPrice }) =>
      dailyPrice ? '70px' : bottomControl ? '257px' : '100px'};
    width: 130px;
  }
`;

export const WarningWrapper = styled.div`
  width: 220px;
  margin-bottom: 15px;
  white-space: normal;
  border-radius: 8px;
  overflow: hidden;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 17px;
    width: 100%;
  }
`;

export const StyledIconLabel = styled(IconLabel)`
  align-items: center;
  flex-direction: inherit;
  border-radius: 8px;
  padding: 8px;
  & span {
    font-size: 14px !important;
    font-weight: 400 !important;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 0;
    margin-top: 10px;
    align-items: center;
  }
`;

export const MobileIconLabelWrapper = styled.div`
  justify-content: space-between;
  margin-bottom: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    white-space: normal;
    justify-content: flex-start;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    & div {
      margin-left: 1px;
    }
    & > div > span {
      margin-top: 4px;
      max-width: 87px;
      margin-left: 3px;
      display: contents;
    }
  }
`;
export const MobileWrapperForCancellation = styled.div`
  min-width: 118px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    min-width: 111px;
    & div {
      margin-left: 1px;
    }
    & > div > span {
      margin-top: 4px;
      max-width: 87px;
      margin-left: 3px;
    }
  }
`;

export const AvailableDatesWrapper = styled.div`
  margin-top: auto;
`;

export const InlineContainer = styled.div`
  display: 'inline-grid';
`;

export const WorldPriceWrapper = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background: #6f328a;
`;

export const WorldPriceTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SeparatorWorld = styled.div`
  width: 1px;
  height: 24px;
  background: #c1c7d0;
`;

export const WorldPriceMobileWrapper = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 2px;
  border-radius: 8px;
  background: #6f328a;
  height: 52px;
`;

export const WorldPriceWrapperMobile = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background: #6f328a;
  height: 38px;
`;

export const WorldPriceContainerMobile = styled.div`
  display: flex;
  padding: 4px 0px;
  justify-content: flex-end;
  align-items: center;
  border-radius: 8px;
  flex-direction: column;
`;

export const WorldPriceTextWrapperMobile = styled.div`
  display: flex;
  align-items: center;
`;
